type SvgProps = {
    className: string,
};

const Info = (props: SvgProps): JSX.Element => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M15.99 19.796v-4.42M15.99 12.204H16" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        <path
            clipRule="evenodd"
            d="M20.334 6.75h-8.668c-3.022 0-4.916 2.139-4.916 5.166v8.168c0 3.027 1.885 5.166 4.915 5.166h8.669c3.03 0 4.916-2.139 4.916-5.166v-8.168c0-3.027-1.886-5.166-4.916-5.166z"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Info;
